import { z } from 'zod';

/**
 * Client env — ONLY `VITE_`-prefixed values reach the browser bundle (never secrets).
 * Parsed + validated once at startup so a misconfiguration fails loudly, not silently.
 */
const schema = z.object({
  /** Backend API base. Absolute in dev (cross-origin, same-site); relative in prod. */
  VITE_API_URL: z.string().default('http://localhost:3010/api/v1'),
  /** Sentry DSN — empty disables the SDK (errors, tracing, web-vitals all no-op). */
  VITE_SENTRY_DSN: z.string().default(''),
  /** Trace sample rate (0–1). Low in prod to bound cost; 1 in dev to see everything. */
  VITE_SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().min(0).max(1).default(0.1),
  /** Release identifier for Sentry (source-map matching + release health). */
  VITE_RELEASE: z.string().default(''),
  VITE_ENV: z.enum(['development', 'staging', 'production']).default('development'),
});

export const env = schema.parse(import.meta.env);
